export default __webpack_public_path__ + "static/media/login-6.8117051e.svg";